import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const vendorOrders = createAsyncThunk('vendorOrders', async ({ navigate,user_id,status }) => {
    console.log(user_id)
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `order_list`,
            params: {
                'user_id': user_id,
                "status": status ? status : ''
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const vendorOrdersSlice = createSlice({
    name: 'vendorOrders',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(vendorOrders.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(vendorOrders.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default vendorOrdersSlice.reducer;
